/**
 * Process-wide flag for whether the app is running inside the Microsoft Teams
 * client. Set once during bootstrap (main.ts) before the Angular app is created,
 * so provider factories (app.config.ts) and route guards (app.routes.ts) can
 * branch synchronously without injecting an async service.
 *
 * Read via `isInTeams()`; written once via `setInTeams()`.
 */
const runtime = { inTeams: false };

export function setInTeams(value: boolean): void {
  runtime.inTeams = value;
}

export function isInTeams(): boolean {
  return runtime.inTeams;
}

/**
 * Cheap synchronous pre-check used before attempting the (async) Teams SDK
 * initialize. Teams always hosts tabs inside an iframe or a native webview, so
 * if we are clearly the top-level window in a normal browser we can skip the
 * SDK probe entirely and avoid delaying first paint.
 */
export function couldBeInsideTeams(): boolean {
  try {
    const inIframe = window.parent !== window.self || window.top !== window.self;
    // Teams desktop/mobile inject a native bridge onto window.
    const hasNativeBridge =
      typeof (window as unknown as { nativeInterface?: unknown }).nativeInterface !==
      'undefined';
    return inIframe || hasNativeBridge;
  } catch {
    // Cross-origin access to window.top throws -> we are framed by another origin.
    return true;
  }
}
